import { useSaveData } from '@entities/common/savedData/index.ts';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFullNameM } from '@shared/helpers/index.ts';
import { useAppDispatch, useUser } from '@shared/hooks';
import { useRecommendedProgramQuery } from '@src/api/api-hooks/programs/useRecommendedProgramQuery.ts';
// import { formatName } from '@src/library/helpers/common/strings';
import { openNotifyModal, openRecommendModal } from 'library/redux/modal';
import { useFavorite } from '../favorite';

export const useUpdateRecommendation = (hash: string) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const { data: isShowedRecommendModal, doSetStorageData: setIsShowedRecommendModal } =
    useSaveData<boolean>('isShowedRecommenProgramdModal');
  const { data, isLoading, isError } = useRecommendedProgramQuery({
    hash: Boolean(hash) ? hash : undefined,
  });

  const program = data?.invite?.program,
    coach = program?.recommendations[0]?.coach,
    message = data?.message,
    isAuth = data?.status === 'auth';

  const { addToFavorite } = useFavorite({
    programId: data?.invite?.program?.pk as number,
    isFavorite: data?.invite?.program?.favorite,
    isPaid: data?.invite?.program?.is_paid,
  });

  useEffect(() => {
    if (coach && program) {
      const fullName = getFullNameM(coach.first_name, coach.middle_name, coach.last_name);
      !isShowedRecommendModal &&
        dispatch(
          openRecommendModal({
            title: 'Рекомендация',
            specialist: `${fullName}`,
            cardName: `${program.title}`,
            text: 'Рекомендую вам видеопрограмму:',
            photo: coach.photo,
            confirmText: 'Ок',
            confirm: () => setIsShowedRecommendModal(true),
          })
        );
    }
  }, [program, coach, dispatch]);

  const closeProgram = async () => {
    // console.log('isAuth:', isAuth);
    // console.log('program.favorite:', program?.favorite);
    const isAuthor = program?.author?.id === user?.id;
    if (!isAuthor && !program?.favorite && isAuth) {
      addToFavorite(true);
      return dispatch(
        openNotifyModal({
          title: 'Уведомление',
          text: 'Для быстрого нахождения рекомендованной видеопрограммы, она добавлена в раздел “Избранное”',
          fullWidthText: true,
          confirmText: 'Ок',
          confirm: () => {
            return navigate('/programs/library');
          },
        })
      );
    } else {
      navigate('/programs/library');
    }
  };

  return { closeProgram, isLoading, isError, program, message };
};
